module.exports = __webpack_public_path__ + "img/img-turfy-umajo-5.e421828b.png";